import { IconSearch, IconX } from '@leland-dev/leland-ui-library';
import React, { useEffect, useState } from 'react';

import TextInput from '../inputs/TextInput';

interface SearchBarProps {
  value?: Possible<string>;
  placeholder?: string;
  onChange: (value: string) => void;
  onClear: () => void;
  onFocus?: () => void;
  className?: string;
  inputContainerClassName?: string;
}

const SearchBar: React.FC<SearchBarProps> = ({
  value,
  placeholder = 'Search',
  onChange,
  onClear,
  onFocus,
  className,
  inputContainerClassName,
}) => {
  const [rawQuery, setRawQuery] = useState<string>(value ?? '');

  useEffect(() => setRawQuery(value ?? ''), [value]);

  return (
    <div
      className={`flex items-center justify-between overflow-hidden border border-leland-gray-stroke px-4 shadow-none transition duration-100 focus-within:border-leland-gray-extra-light focus-within:shadow-sm ${className}`}
    >
      <div className="flex w-full items-center justify-start">
        <IconSearch className="size-4.5 text-leland-gray-extra-light" />
        <TextInput
          label="Search"
          labelIsHidden
          id="search_bar--input"
          placeholder={placeholder}
          className="w-full"
          inputContainerClassName={`w-full outline-none focus:outline-none border-0 ${inputContainerClassName}`}
          value={rawQuery}
          onChangeValue={(value: string) => {
            setRawQuery(value);
            onChange(value);
          }}
          onFocus={onFocus}
        />
      </div>
      {rawQuery ? (
        <button type="button" onClick={onClear} id="search_bar--clear_button">
          <IconX className="size-4.5 text-leland-gray-dark" />
        </button>
      ) : null}
    </div>
  );
};

export default SearchBar;
